document.addEventListener("DOMContentLoaded", function () {
    const tabletMenu = document.querySelectorAll(".tablet-toggle");
    const tabletClose = document.getElementById("tablet-menu-close");
    const tabletOpen = document.getElementById("tablet-menu");
    const navMain = document.getElementById("nav-main");
    const navSide = document.getElementById("nav-side");
  
    tabletMenu.forEach(function (menu) {
      menu.addEventListener("click", function () {
        if (navMain.classList.contains("show-nav-main")) {
          navMain.classList.remove("show-nav-main");
          navSide.classList.add("show-nav-side");
          navSide.classList.remove("hide-nav-side");
          tabletOpen.classList.remove("tablet-menu-active");
          tabletClose.style.display = "none";
        } else {
          navMain.classList.add("show-nav-main");
          navSide.classList.remove("show-nav-side");
          navSide.classList.add("hide-nav-side");
          tabletOpen.classList.add("tablet-menu-active");
          tabletClose.style.display = "block";
        }
      });
    });

    const toggleClass = (selector) => {
        document.querySelectorAll(selector).forEach(element => {
            element.classList.toggle('hidden');
        });
    };

    document.querySelectorAll('.address-edit-toggle').forEach(button => {
        button.addEventListener('click', () => {
          toggleClass('.address');
          toggleClass('#AddressNewForm');
        });
    });

    const dropdown = document.getElementById('urlDropdown');

    if (dropdown) {
        dropdown.addEventListener('change', (event) => {
            const selectedUrl = event.target.value;
            if (selectedUrl) {
                window.location.href = selectedUrl;
            }
        });
    }



  });
  